import { createI18n } from 'vue-i18n'

import enLocale from 'element-plus/dist/locale/en.mjs';
import zhLocale from 'element-plus/dist/locale/zh-cn.mjs';

import en from './i18n/en.json';
import zh from './i18n/zh.json';

const messages = {
  'en': { ...en, ...enLocale },
  'zh': { ...zh, ...zhLocale }
}

const i18n = createI18n({
  legacy: true,
  locale: 'zh',
  fallbackLocale: 'en',
  messages,
  silentTranslationWarn: true
});

export default i18n;
